import { render, staticRenderFns } from "./OtherNames.vue?vue&type=template&id=31533201&scoped=true"
import script from "./OtherNames.vue?vue&type=script&lang=js"
export * from "./OtherNames.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31533201",
  null
  
)

export default component.exports